import React from 'react';
import { Bonuses, FAQ, Guarantee, PainAndSolution, ProductOverview, Testimonials } from './components/ContentSections';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { Pricing } from './components/Offers';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-canvas text-slate-600 selection:bg-primary selection:text-white" data-id="element-0" data-mp="2rit1x23ijoou">
      <MetaPixel data-id="element-1" data-mp="31agnimde2bie" />
      <TopBar data-id="element-2" data-mp="31ayr642drs0c" />
      <main data-id="element-3" data-mp="31brz38d2snk2">
        <Hero data-id="element-4" data-mp="31c9ts0k3atpv" />
        <Testimonials data-id="element-5" data-mp="31cte1nx7pu72" />
        <PainAndSolution data-id="element-6" data-mp="2wk0ah3dhcrwk" />
        <ProductOverview data-id="element-7" data-mp="2wjqgl4pbe0ll" />
        <Bonuses data-id="element-8" data-mp="2wiffjcn976y6" />
        <Pricing data-id="element-9" data-mp="2whx8rm2ytac0" />
        <FAQ data-id="element-10" data-mp="28ufqch5lbolp" />
        <Guarantee data-id="element-11" data-mp="28u5uwe1s0p8m" />
      </main>
      <Footer data-id="element-12" data-mp="28t4lee0esat0" />
      <FloatingElements data-id="element-13" data-mp="28sur4e8bzhhi" />
      <noscript data-id="element-14" data-mp="28s2ynca15zvg">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-15" data-mp="23vkuoemiy5k6" />
      </noscript>
    </div>;
}